import * as z from "zod";

const baseAttributionSettings = z.object({ enabled: z.boolean() });

export type RecoverAttribution = z.infer<typeof RecoverAttributionSchema>;
export const RecoverAttributionSchema = z.object({
  discountSettings: baseAttributionSettings,
  clickSettings: baseAttributionSettings.extend({ windowDays: z.number() }),
  meaningfulConversationSettings: baseAttributionSettings.extend({
    windowDays: z.number(),
    inboundMessageCountThreshold: z.number(),
    messageFrequencyWindowHours: z.number(),
  }),
});

/**
 * What a team gets when it has no saved attribution settings. Only the admin
 * page writes them, so every self-serve Recover team starts without any.
 */
export const DEFAULT_RECOVER_ATTRIBUTION: RecoverAttribution = {
  discountSettings: { enabled: true },
  clickSettings: { enabled: false, windowDays: 1 },
  meaningfulConversationSettings: {
    enabled: false,
    windowDays: 1,
    inboundMessageCountThreshold: 2,
    messageFrequencyWindowHours: 24,
  },
};

/**
 * Step-level attribution overrides — only controls which methods are enabled.
 * Detailed settings (windowDays, thresholds, etc.) are always inherited from
 * team-level admin settings. Nested structure kept so it's easy to inline
 * the full settings later if needed.
 */
export type RecoverStepAttribution = z.infer<
  typeof RecoverStepAttributionSchema
>;
export const RecoverStepAttributionSchema = z.object({
  discountSettings: baseAttributionSettings,
  clickSettings: baseAttributionSettings,
  meaningfulConversationSettings: baseAttributionSettings,
});
